import {Component, Input} from '@angular/core';
import {Client} from '../client';

@Component({
    selector: 'zah-client-header',
    templateUrl: './client-header.component.html',
    styleUrls: ['./client-header.component.scss'],
    standalone: false
})
export class ClientHeaderComponent {

  @Input()
  client: Client;
  @Input()
  label: string;
}
